<script setup>
const { toasts, removeToast } = useToast();
//TODO Disable Button for few min
</script>

<template>
  <div class="toast toast-top toast-end z-9999">
    <TransitionGroup name="list">
      <div 
        v-for="toast in toasts" 
        :key="toast.id"
        :class="['alert shadow-lg mb-2 flex justify-between min-w-75', toast.type]"
      >
        <span>{{ toast.message }}</span>
        <button class="btn btn-ghost btn-xs" @click="removeToast(toast.id)">✕</button>
      </div>
    </TransitionGroup>
  </div>
</template>

<style scoped>
/* Animation for stacking */
.list-enter-active, .list-leave-active { transition: all 0.5s ease; }
.list-enter-from { opacity: 0; transform: translateX(30px); }
.list-leave-to { opacity: 0; transform: scale(0.9); }
</style>